import { createFileRoute } from "@tanstack/react-router";
import { SelskapPage } from "@/features/selskap/SelskapPage";

export const Route = createFileRoute("/_app/selskap")({
  component: SelskapPage,
  head: () => ({
    meta: [
      {
        title: "Velg Selskap | Selskapsportal for fjernvarme",
      },
    ],
  }),
});
